import client from '../thinMintClient'
import { resolvePledgeDown, resolvePledgeUp } from './resolver'
import { Pledge, PledgeForm, ServerPledge } from './types'

export const baseEndpoint = '/pledges'

export const getPledges = () =>
  client
    .get<Pledge[]>(`${baseEndpoint}/`)
    .then((res) => res.data.map(resolvePledgeDown) as Pledge[])

export const getPledgesWithAuthToken = (token: string) =>
  client
    .get<Pledge[]>(`${baseEndpoint}/`, {
      headers: {
        Authorization: token,
      },
    })
    .then((res) => res.data.map(resolvePledgeDown) as Pledge[])

export const createPledge = (pledgeForm: PledgeForm) =>
  client
    .post<ServerPledge>(`${baseEndpoint}/`, resolvePledgeUp(pledgeForm))
    .then((res) => resolvePledgeDown(res.data) as Pledge)

export const updatePledge = (pledgeId: number, pledgeForm: PledgeForm) =>
  client
    .put<ServerPledge>(
      `${baseEndpoint}/${pledgeId}/`,
      resolvePledgeUp(pledgeForm)
    )
    .then((res) => resolvePledgeDown(res.data) as Pledge)
